import { defineComponent as t, openBlock as n, createBlock as r, unref as l, mergeProps as p, withCtx as i, createElementVNode as m } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const u = /* @__PURE__ */ t({
  name: "IconFile",
  __name: "IconFile",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const o = a;
    return (v, e) => (n(), r(l(c), p(o, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        m("path", {
          "fill-rule": "evenodd",
          d: "M2.25 6.5A2.25 2.25 0 0 1 4.5 4.25h4.691a1.25 1.25 0 0 1 1.118.691l1.155 2.309H19.5a2.25 2.25 0 0 1 2.25 2.25v8a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25v-11m1.5 0A.75.75 0 0 1 4.5 5.75h4.536l1.155 2.309a1.25 1.25 0 0 0 1.118.691H19.5a.75.75 0 0 1 .75.75v1.263a2.3 2.3 0 0 0-.75-.128h-8.207l-1.14-1.053A1.25 1.25 0 0 0 9.304 9.25H4.5a2.3 2.3 0 0 0-.75.128V6.5m0 5v6a.75.75 0 0 0 .75.75h15a.75.75 0 0 0 .75-.75v-4.615a.75.75 0 0 0-.75-.75h-8.304a1.25 1.25 0 0 1-.848-.332L9.207 10.75H4.5a.75.75 0 0 0-.75.75",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
